import moment from "moment-timezone";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { ClickableCellRenderer } from "tap/components/AGGrid/cell-renderers/ClickableCellRenderer.jsx";
import Pillbox from "@dtci/spellbook/Pillbox";
// --- Helpers
import { getColorForStatus } from "../../../utils/windowHelpers";

export const statusIndicator = {
  headerName: "",
  field: "status",
  width: 20,
  cellRenderer: ({ value }) => (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        background: "#fff",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 2,
          top: 0,
          bottom: 0,
          width: "4px",
          background: getColorForStatus(value),
          borderRadius: "2px",
        }}
      />
      <span
        style={{
          marginLeft: "4px",
          background: getColorForStatus(value),
          display: "inline-block",
          width: "100%",
          height: "100%",
        }}
      >
        &nbsp;
      </span>
    </div>
  ),
  cellStyle: { padding: 0 },
  suppressHeaderMenuButton: true,
  sortable: false,
  filter: false,
};

export const view = (onOpenViewDrawer) => ({
  field: "",
  headerName: "",
  cellRenderer: ClickableCellRenderer(onOpenViewDrawer, "fa-eye"),
  width: 20,
});

export const edit = (onOpenEditDrawer) => ({
  field: "",
  headerName: "",
  cellRenderer: ClickableCellRenderer(onOpenEditDrawer, "fa-pencil"),
  width: 20,
});

export const id = {
  field: "id",
  headerName: "ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "windows",
  },
  width: 100,
};

export const windowSequenceName = {
  field: "windowSequenceName",
  headerName: "Name",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "windowSequenceName",
    page: "windows",
  },
  minWidth: 300,
};

export const windows = {
  field: "windows",
  headerName: "Windows",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "windows",
    page: "windows",
  },
  minWidth: 400,
  sortable: false,
  autoHeight: true,
  wrapText: true,
  valueFormatter: ({ value }) =>
    Array.isArray(value)
      ? value.map((w) => w.windowName || w.label).join(", ")
      : "",
  cellRenderer: ({ value }) => {
    if (!value || !Array.isArray(value)) return "";
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px",
          padding: "8px 0",
        }}
      >
        {value.map((window, index) => (
          <Pillbox
            key={index}
            badgeRole="listitem"
            color="primary"
            light
            showClose={false}
            size="small"
          >
            {window.windowName || window.label}
          </Pillbox>
        ))}
      </div>
    );
  },
};

export const status = {
  field: "status",
  headerName: "Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "status",
    page: "windows",
  },
  width: 20,
  cellRenderer: ({ value }) => {
    let iconType, color;
    if (value === "ACTIVE") {
      iconType = "fa-regular fa-circle-check";
      color = "#4caf50";
    } else if (value === "INACTIVE") {
      iconType = "fa-regular fa-circle-xmark";
      color = "red";
    } else if (value === "NEEDS_ATTENTION") {
      iconType = "fa-solid fa-triangle-exclamation";
      color = "orange";
    } else {
      return "";
    }
    return <i className={iconType} style={{ color }}></i>;
  },
};

export const createdBy = {
  field: "createdBy.fullName",
  headerName: "Created By",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdBy",
    page: "windows",
  },
  minWidth: 150,
};

export const createdAt = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value ? moment(value, "MMM DD, YYYY, h:mm:ss A").format("DD-MMM-YYYY") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "windows",
  },
  minWidth: 150,
};

export const updatedBy = {
  field: "modifiedBy.fullName",
  headerName: "Updated By",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "updatedBy",
    page: "windows",
  },
  minWidth: 150,
};

export const modifiedAt = {
  field: "modifiedAt",
  headerName: "Modified",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value, "MMM DD, YYYY, h:mm:ss A").toDate())
          .tz(moment.tz.guess())
          .format("DD-MMM-YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "modifiedAt",
    page: "windows",
  },
  minWidth: 200,
};
